export const profileImg =
  "https://firebasestorage.googleapis.com/v0/b/holidaying-prod.appspot.com/o/concierge%2FUntitled%20design%20(4).png?alt=media&token=5164cda7-e6a0-439a-9d7e-9e7760538031";

export const name = "Megha";
export const colors = [
  "from-gray-400",
  "from-orange-500",
  "from-purple-400",
  "from-blue-500",
  "from-yellow-500",
  "from-indigo-500",
];
